import { jwtDecode } from 'jwt-decode';
import { UserLogin } from '../types/ILogin';

const decodeJWT = (token: string): UserLogin | null => {
  try {
    // Decode the JWT token into a UserLogin object
    const decoded: UserLogin = jwtDecode(token);

    // Ensure decoded token has an expiration field
    if (!decoded.exp) {
      console.error('Token does not contain an expiration timestamp.');
      return null;
    }
     decoded.token = token; // Add the original token to the decoded object
    // Check if the token is expired
    const currentTime = new Date().getTime();
    const expirationTime = decoded.exp * 1000; // Convert seconds to milliseconds
    const isExpired = expirationTime < currentTime;

    if (isExpired) {
      console.error('Token is expired.');
      return null; // Return null if the token is expired
    }

    return decoded; // Return decoded user details if valid
  } catch (error) {
    console.error('Failed to decode token:', error);
    return null; // Return null if decoding fails
  }
};

export default decodeJWT;
